// Check if user is on mobile.
function isMobile() {
  return window.dfp_visibility === 'mobile';
}

// Close scope explanation tooltip.
function closeScopeTooltip() {
  $('.js-semantic-scope-tooltip').prop('hidden', true);
  $('.js-semantic-scope-tooltip-trigger').attr('aria-expanded', 'false');
}

let tooltipObserver = null;

// Set up intersection observer for mobile tooltip scroll behavior.
function setupTooltipScrollObserver($tooltip) {
  if (!isMobile() || !$tooltip.length || !('IntersectionObserver' in window)) {
    return;
  }

  // Clean up existing observer if any.
  if (tooltipObserver) {
    tooltipObserver.disconnect();
  }

  tooltipObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // If tooltip is open and has scrolled out of view, close it.
      if (!entry.isIntersecting && !$tooltip.prop('hidden')) {
        closeScopeTooltip();
      }
    });
  }, {
    threshold: 0, // Trigger as soon as any part leaves viewport.
  });

  tooltipObserver.observe($tooltip[0]);
}

// Wire up scope tooltip interactions (click, hover, outside click, Escape).
export default function installScopeTooltip() {
  // Toggle tooltip when info icon is clicked (mobile behavior).
  $(document).on('click', '.js-semantic-scope-tooltip-trigger', (e) => {
    e.stopPropagation();
    const $trigger = $(e.currentTarget);
    const $tooltip = $trigger.siblings('.js-semantic-scope-tooltip');
    const shouldOpen = $tooltip.prop('hidden');
    closeScopeTooltip();
    if (shouldOpen) {
      $tooltip.prop('hidden', false);
      $trigger.attr('aria-expanded', 'true');
      // Set up scroll observer when tooltip opens on mobile.
      setupTooltipScrollObserver($tooltip);
    }
  });

  // Desktop hover behavior - open on mouseenter, close on mouseleave.
  if (!isMobile()) {
    $(document).on('mouseenter', '.semantic-search-form__scope-info', (e) => {
      const $info = $(e.currentTarget);
      const $trigger = $info.find('.js-semantic-scope-tooltip-trigger');
      const $tooltip = $info.find('.js-semantic-scope-tooltip');
      $tooltip.prop('hidden', false);
      $trigger.attr('aria-expanded', 'true');
    });

    $(document).on('mouseleave', '.semantic-search-form__scope-info', () => {
      closeScopeTooltip();
    });
  }

  // Close tooltip when clicking outside (mobile).
  $(document).on('click', (e) => {
    if (!$(e.target).closest('.semantic-search-form__scope-info').length) {
      closeScopeTooltip();
    }
  });

  // Close tooltip on ESC key.
  $(document).on('keydown', (e) => {
    if (e.key === 'Escape') {
      closeScopeTooltip();
    }
  });
}
